import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AuthCallbackPage from './pages/AuthCallbackPage';
import { i18nPromise } from './i18n'; // Import the initialization promise

// This code is the main entry point for the browser.
// The check below ensures that it ONLY runs in a client-side environment
// and will be skipped during server-side prerendering, preventing crashes.
if (typeof window !== 'undefined') {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Could not find root element to mount to");
  }

  // Intercept OAuth callback before rendering the full app
  const isCallbackPath = window.location.pathname === '/auth/callback' || window.location.pathname === '/auth/callback/' || window.location.hash.startsWith('#/auth/callback');
  if (isCallbackPath && (window.location.hash.includes('id_token=') || window.location.search.includes('error='))) {
    ReactDOM.createRoot(rootElement).render(<AuthCallbackPage />);
  } else {
    const app = (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // DEFINITIVE FIX: Wait for i18next to finish loading translations
    // before rendering the React application. This prevents the app from
    // rendering with missing translations and ensures all content is
    // ready from the first paint.
    i18nPromise.then(() => {
      // Using createRoot(...).render(...) is the standard for React 18+.
      ReactDOM.createRoot(rootElement).render(app);
    });
  }
}
